<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>The Avignon Quintet</span></p>
<p class="subtitle"><span>Monsieur, Livia, Constance, Sebastian, and Quinx</span></p>
<p class="authorname"><span>Lawrence Durrell</span></p>
<p class="publisher"><span><img alt="img" src="Backed/img/logo1.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?14007420